<template>
  <article>
    <div class="small-form" v-if="!isLoggedIn">
      <h1>Login to your account</h1>
      <form novalidate="novalidate">
        <fieldset>
          <div class="form-header">
            <h3>Login:</h3>
          </div>
          <div class="form-group">
            <input
              type="email"
              v-model="email"
              class="form-control"
              placeholder="E-mail address"
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              v-model="password"
              class="form-control"
              placeholder="Password"
            />
          </div>
        </fieldset>
        <div v-if="loginMessage" class="alert alert-danger">
          {{ loginMessage }}
        </div>
        <button
          type="submit"
          @click.prevent="attemptLogin(email, password)"
          class="btn btn-primary btn-default btn-block"
        >
          Login
        </button>
        <!-- <a href="forgot-password/" class="btn btn-link btn-block">Forgot your password?</a>
        <a href="forgot-email/" class="btn btn-link btn-block">Forgot your e-mail?</a>
        <a href="/create-account/" class="btn btn-link btn-block">Create an account</a> -->
      </form>
    </div>
    <div v-if="isLoggedIn">
      <h1>Welcome {{ username }}</h1>

      <a href="javascript:void 0" @click="logout()" class="btn btn-primary"
        >logout</a
      >
    </div>
  </article>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      email: '',
      password: '',
      loginMessage: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'username']),
  },
  methods: {
    ...mapActions('auth', ['login', 'logout']),
    attemptLogin(username, password) {
      this.loginMessage = ''
      this.login({ username, password }).then(result => {
        this.loginMessage = result.message
        this.$router.push('/')
      })
    },
  },
}
</script>

<style lang="scss">
.small-form {
  text-align: center;

  form {
    width: 268px;
    margin: 0 auto;
  }

  .form-header {
    text-align: left;
  }
}
</style>
